// src/shared/docLines.js — общото за редовете на фактура и проформа
// (Промени 16.10.2026): мерната единица на реда (т. 3й), падащото меню за
// начина на плащане (т. 3д) и „последната цена за този клиент" (т. 5а).

import { el } from './dom.js';
import { money, dfmt } from './format.js';
import { PAYMENT_METHODS } from '../../services/payment.js';
import priceLists from '../../services/priceLists.js';

// Честите мерни единици — подсказка в полето „Мярка"; може и друга.
export const UNITS = ['бр.', 'кг', 'г', 'т', 'л', 'мл', 'м', 'м²', 'м³', 'км', 'час', 'ден', 'месец', 'услуга', 'к-т', 'пакет', 'кашон', 'стек', 'палет'];

// Един datalist на документ: полетата „Мярка" на всички редове сочат към него.
export function unitDatalist(id) {
  return el('datalist', { id }, ...UNITS.map((u) => el('option', { value: u })));
}

// Падащото меню „Начин на плащане". Заварен документ с друг текст (писан на
// ръка преди менюто) пази своя — показва се като отделна опция, за да не го
// подмени тихо отварянето и записът.
export function paymentSelect(current) {
  const cur = String(current || '').trim();
  const known = PAYMENT_METHODS.some((p) => p.value === cur);
  const sel = el('select', {},
    ...PAYMENT_METHODS.map((p) => el('option', { value: p.value, text: p.label, selected: (cur || PAYMENT_METHODS[0].value) === p.value })),
    (cur && !known) ? el('option', { value: cur, text: cur + ' (заварено)', selected: true }) : null);
  return sel;
}

// Последната цена, на която ТОЗИ клиент е купил ТОЗИ артикул (или ред със
// същото описание, ако е без артикул) — само за сведение до реда (т. 5а).
// invoices: фактурите на фирмата; selfId: документът, който се редактира
// (своята цена не е „история"). Кредитните известия не са цена на продажба.
export function lastPriceFor(invoices, contactId, item, selfId) {
  if (!contactId || !item || !Array.isArray(invoices)) return null;
  const art = item.article_id != null && item.article_id !== '' ? Number(item.article_id) : null;
  const desc = String(item.description || '').trim().toLowerCase();
  if (art == null && !desc) return null;
  let best = null;
  for (const inv of invoices) {
    if (String(inv.contact_id) !== String(contactId)) continue;
    if (selfId != null && String(inv.id) === String(selfId)) continue;
    if ((inv.doc_type || 'invoice') === 'credit') continue;
    for (const it of (Array.isArray(inv.items) ? inv.items : [])) {
      const hit = art != null ? Number(it.article_id) === art : String(it.description || '').trim().toLowerCase() === desc;
      if (!hit) continue;
      const key = String(inv.issue_date || '') + '|' + String(inv.number || '');
      if (!best || key > best.key) best = { key, price: Number(it.unit_price) || 0, unit: it.unit || '', number: inv.number, date: inv.issue_date, currency: inv.currency || 'EUR' };
    }
  }
  return best;
}

// Текстът на подсказката под реда.
export function lastPriceText(lp) {
  if (!lp) return '';
  return 'Последно на този клиент: ' + money(lp.price, lp.currency) + (lp.unit ? ' / ' + lp.unit : '') + ' (ф-ра № ' + lp.number + ' от ' + dfmt(lp.date) + ')';
}

// Цената по ценовата листа на клиента (т. 5 a): { price, how, pct?, list }
// или null. lists — листите на фирмата; contact — клиентът на документа;
// article — артикулът от каталога; date — датата на документа (ISO).
export function listPriceFor(lists, contact, article, date) {
  return priceLists.priceFor(priceLists.listOf(lists, contact), article, date);
}

// „Цена по листа „Едро": 3,90 €" (с процента, ако цената идва от него).
export function listPriceText(r) {
  if (!r) return '';
  return 'Цена по листа „' + r.list + '“: ' + money(r.price, 'EUR') + (r.how === 'pct' ? ' (−' + String(r.pct).replace('.', ',') + ' %)' : '');
}

// Смяна на клиента: редовете, чиято цена е сложена автоматично (it._auto) от
// каталога, минават на цената по листата на новия клиент (или на основната).
// Пипната на ръка цена остава. Връща колко реда са сменени.
export function repriceAuto(items, cat, lists, contact, date) {
  let n = 0;
  for (const it of items) {
    if (!it || !it._auto || it.article_id == null || it.article_id === '') continue;
    const a = (cat || []).find((x) => Number(x.id) === Number(it.article_id));
    if (!a) continue;
    const r = listPriceFor(lists, contact, a, date);
    const price = r ? r.price : (Number(a.unit_price) || 0);
    if (Number(it.unit_price) !== price) { it.unit_price = price; n++; }
  }
  return n;
}
